(function () {
  'use strict';
  if (window.__ANATOMY_OVERLAY_GUARD__) return;
  window.__ANATOMY_OVERLAY_GUARD__ = true;

  var overlaySelector = '[class*="kl-teaser-"][class*="kl-private-reset-css"]';
  var commerceSelector = '.product-sticky-form, .lp-sticky-cta, [data-an-transaction-rail-sticky]';
  var frameId = 0;
  var forceNextAdjustment = false;
  var resizeObserver = null;
  var observedElements = typeof WeakSet === 'function' ? new WeakSet() : null;

  function visible(element) {
    if (!element || element.hidden) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function commerceRects() {
    var rects = [];
    document.querySelectorAll(commerceSelector).forEach(function (element) {
      observeSize(element);
      if (!visible(element)) return;
      var rect = element.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
      rects.push(rect);
    });
    return rects;
  }

  function rememberBottom(element) {
    if (element.dataset.anOverlayAdjusted === 'true') return;
    element.dataset.anOverlayOriginalBottom = element.style.getPropertyValue('bottom');
    element.dataset.anOverlayOriginalBottomPriority = element.style.getPropertyPriority('bottom');
  }

  function restoreBottom(element) {
    if (element.dataset.anOverlayAdjusted !== 'true') return;
    var value = element.dataset.anOverlayOriginalBottom || '';
    var priority = element.dataset.anOverlayOriginalBottomPriority || '';
    if (value) element.style.setProperty('bottom', value, priority);
    else element.style.removeProperty('bottom');
    delete element.dataset.anOverlayAdjusted;
    delete element.dataset.anOverlayOriginalBottom;
    delete element.dataset.anOverlayOriginalBottomPriority;
  }

  function observeSize(element) {
    if (!resizeObserver || !observedElements || observedElements.has(element)) return;
    observedElements.add(element);
    resizeObserver.observe(element);
  }

  function overlapsHorizontally(first, second) {
    return first.left < second.right + 8 && first.right > second.left - 8;
  }

  function adjust() {
    var rails = commerceRects();
    document.querySelectorAll(overlaySelector).forEach(function (element) {
      if (element.closest('.an-klaviyo-form-host')) return;
      observeSize(element);
      restoreBottom(element);
      if (!visible(element) || window.getComputedStyle(element).position !== 'fixed') return;
      var rect = element.getBoundingClientRect();
      var collisionTop = window.innerHeight;
      rails.forEach(function (rail) {
        if (!overlapsHorizontally(rect, rail)) return;
        if (rect.bottom <= rail.top - 8 || rect.top >= rail.bottom + 8) return;
        collisionTop = Math.min(collisionTop, rail.top);
      });
      if (collisionTop === window.innerHeight) return;
      var nextBottom = Math.max(0, window.innerHeight - collisionTop + 12) + 'px';
      rememberBottom(element);
      element.style.setProperty('bottom', nextBottom, 'important');
      element.dataset.anOverlayAdjusted = 'true';
    });
  }

  function scheduleAdjust(force) {
    forceNextAdjustment = forceNextAdjustment || force === true;
    if (frameId) return;
    frameId = window.requestAnimationFrame(function () {
      frameId = 0;
      forceNextAdjustment = false;
      adjust();
    });
  }

  function initialize() {
    if (typeof ResizeObserver === 'function') {
      resizeObserver = new ResizeObserver(function () {
        scheduleAdjust(true);
      });
    }
    scheduleAdjust(true);
    window.addEventListener('resize', function () { scheduleAdjust(true); }, { passive: true });
    window.addEventListener('scroll', function () { scheduleAdjust(false); }, { passive: true });
    window.addEventListener('pageshow', function () { scheduleAdjust(true); });
    document.addEventListener('shopify:section:load', function () { scheduleAdjust(true); });
    new MutationObserver(function () {
      scheduleAdjust(true);
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  }
  else {
    initialize();
  }
})();
